class ComparisonTable extends HTMLElement {
  constructor () {
    super()
    this.compareTable = null
    this.compareNoneSelected = null
    this.compareProductHeader = null
    this.compareCheckboxesWrapper = null
    this.compareCheckboxesMessage = null
  }

  connectedCallback () {
    this.initializeElements()
    this.setupEventListeners()

    this.applyParamsFromURL()

    this.updateDisplayState()
  }

  initializeElements () {
    this.compareTable = this.querySelector('#compare_table')
    this.compareNoneSelected = this.querySelector('#compare_none_selected')
    this.compareProductHeader = this.querySelectorAll('.compare-product-header')
    this.compareCheckboxesWrapper = this.querySelector('#compare_checkboxes_wrapper')
    this.compareCheckboxesMessage = this.querySelector('#compare_checkboxes_message')
  }

  setupEventListeners () {
    this.querySelectorAll('.compare-checkbox').forEach((checkbox) => {
      checkbox.addEventListener('click', (event) => this.handleCheckboxClick(event))
    })
  }

  handleCheckboxClick (event) {
    const checkbox = event.target
    const columnHide = checkbox.dataset.columnHide

    this.compareTable.classList.toggle(`tb-compare-hide-${columnHide}`)
    this.updateDisplayState()

    this.updateURLParams()
  }

  applyParamsFromURL () {
    const params = new URLSearchParams(window.location.search)
    const compareParam = params.get('compare')

    if (compareParam) {
      const labels = compareParam.split('-').map(label => decodeURIComponent(label).replace(/\s+/g, ''))
      this.querySelectorAll('.compare-checkbox').forEach((checkbox) => {
        const labelElement = checkbox.nextElementSibling
        const labelText = labelElement.textContent.trim().replace(/\s+/g, '')
        if (labels.includes(labelText)) {
          checkbox.checked = true
          this.compareTable.classList.remove(`tb-compare-hide-${checkbox.dataset.columnHide}`)
        } else {
          checkbox.checked = false
          this.compareTable.classList.add(`tb-compare-hide-${checkbox.dataset.columnHide}`)
        }
      })
    } else {
      this.setDefaultParams()
    }

    this.updateURLParams()
  }

  setDefaultParams () {
    const defaultLabels = []
    this.querySelectorAll('.compare-checkbox').forEach((checkbox) => {
      const labelElement = checkbox.nextElementSibling
      if (checkbox.checked) {
        defaultLabels.push(labelElement.textContent.trim().replace(/\s+/g, ''))
      }
    })
    if (defaultLabels.length > 0) {
      const params = new URLSearchParams(window.location.search)
      params.set('compare', defaultLabels.map(encodeURIComponent).join('-'))
      const newUrl = `${window.location.pathname}?${params.toString()}`
      window.history.replaceState({}, '', newUrl)
    }
  }

  updateURLParams () {
    const checkedLabels = []
    this.querySelectorAll('.compare-checkbox').forEach((checkbox) => {
      if (checkbox.checked) {
        const labelElement = checkbox.nextElementSibling
        const labelText = labelElement.textContent.trim().replace(/\s+/g, '')
        checkedLabels.push(labelText)
      }
    })

    const params = new URLSearchParams(window.location.search)
    if (checkedLabels.length > 0) {
      params.set('compare', checkedLabels.map(encodeURIComponent).join('-'))
    } else {
      params.delete('compare')
    }
    const newUrl = `${window.location.pathname}?${params.toString()}`
    window.history.replaceState({}, '', newUrl)
  }

  updateDisplayState () {
    const checkedCount = this.countCheckedCheckboxes()
    this.updateCheckboxMessage(checkedCount)
    this.toggleCheckboxesState(checkedCount)
    this.updateTableAndHeaders(checkedCount)
  }

  countCheckedCheckboxes () {
    return this.querySelectorAll('input.compare-checkbox:checked').length
  }

  updateCheckboxMessage (count) {
    this.compareCheckboxesMessage.textContent = count
  }

  toggleCheckboxesState (count) {
    const uncheckedCheckboxes = this.querySelectorAll('input.compare-checkbox:not(:checked)')
    const isThreeChecked = count === 3
    uncheckedCheckboxes.forEach((checkbox) => (checkbox.disabled = isThreeChecked))
  }

  updateTableAndHeaders (count) {
    if (count === 0) {
      this.compareTable.classList.replace('tb-table', 'tb-hidden')
      this.compareNoneSelected.classList.remove('tb-hidden')
      this.compareCheckboxesWrapper.classList.replace('bg-sheep', 'bg-honey/50')
    } else {
      this.compareTable.classList.replace('tb-hidden', 'tb-table')
      this.compareNoneSelected.classList.add('tb-hidden')
      this.compareCheckboxesWrapper.classList.replace('bg-honey/50', 'bg-sheep')
      this.adjustHeaderWidths(count)
    }
  }

  adjustHeaderWidths (count) {
    const widthClasses = {
      1: 'tb-w-3/4',
      2: 'tb-w-3/8',
      3: 'tb-w-1/4',
    }

    this.compareProductHeader.forEach((header) => {
      header.classList.remove('tb-w-3/4', 'tb-w-3/8', 'tb-w-1/4')
      if (widthClasses[count]) {
        header.classList.add(widthClasses[count])
      } else {
        header.classList.add('tb-w-1/4')
      }
    })
  }
}

if (!customElements.get('comparison-table')) {
  customElements.define('comparison-table', ComparisonTable)
}
